import { Box, Link } from "@mui/material";
import Text from "../../../../../../../../components/Text";

type SelectDeselectAllProps = {
  selectAll: () => void;
  deselectAll: () => void;
};

export const SelectDeselectAll = ({
  selectAll,
  deselectAll,
}: SelectDeselectAllProps) => {
  return (
    <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
      <Link
        component="button"
        onClick={deselectAll}
        underline="hover"
        sx={{ fontSize: "0.875rem", cursor: "pointer" }}
      >
        Deselect all
      </Link>
      <Text sx={{ color: "text.disabled" }}>|</Text>
      <Link
        component="button"
        onClick={selectAll}
        underline="hover"
        sx={{ fontSize: "0.875rem", cursor: "pointer" }}
      >
        Select all
      </Link>
    </Box>
  );
};
